import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private currentPermissionSubject = new BehaviorSubject<any>(this.loadFromStorage());
  currentPermission = this.currentPermissionSubject.asObservable();

  private permissions: { [url: string]: { isRead: boolean; isEdit: boolean; isApprove: boolean; isDownload: boolean } } = {};

  setPermission(url: string, isRead: boolean, isEdit: boolean, isApprove: boolean, isDownload: boolean): void {
    this.permissions[url] = { isRead, isEdit, isApprove, isDownload };
  }

  getPermission(url: string): { isRead: boolean; isEdit: boolean; isApprove: boolean; isDownload: boolean } | undefined {
    return this.permissions[url];
  }

  setPrivilege(url:string,isRead: boolean, isEdit: boolean, isApprove: boolean, isDownload: boolean): void {
    const permission: { [url: string]: { isRead: boolean; isEdit: boolean; isApprove: boolean; isDownload: boolean } } = {};
    permission[url] = { isRead, isEdit, isApprove, isDownload };
    this.currentPermissionSubject.next(permission);
    localStorage.setItem('permission', JSON.stringify(permission)); 
  }

  getPrivilege(): { 
    [url: string]: { isRead: boolean; isEdit: boolean; isApprove: boolean; isDownload: boolean }
  } {
    return this.currentPermissionSubject.value;
  }

  private loadFromStorage(): any {
    const stored = localStorage.getItem('permission');
    return stored ? JSON.parse(stored) : null;
  }
}
